import { Toast } from "../../dialog/toast";
import { AuxiliumComponent } from "../auxilium-component";

export class CodeBlock extends AuxiliumComponent {
	static observedAttributes = ["autowrap", "language"];

	constructor() {
		super();

		this.language = this.getAttribute("language");
		this.autowrap = this.hasAttribute("autowrap");
		this.hideButton = this.hasAttribute("hide-button");
	}

	parsedCallback() {
		const codeElement = this.querySelector("code"),
			row = document.createElementWithContents("div", document.createElementWithContents("div", null, { className: "col" }), { className: "row" });

		if (codeElement) {
			if (!this.autowrap) {
				codeElement.trimBreaks();
			}

			codeElement.innerHTML = codeElement.innerHTML.trimEnd();

			if (this.language) {
				codeElement.classList.add(`language-${this.language}`);
			}
		}
		this.querySelector("code")?.trimBreaks();

		row.firstElementChild.appendChild(document.createElementWithContents("pre", this.childNodes));

		if (!this.hideButton) {
			const copyButton = document.createElementWithContents("chip-button", null, {
				buttonStyle: "icon",
				icon: "fal fa-copy",
				variation: "body",
				size: "sm",
				className: "btn--copy-code",
				tooltip: "Copy code"
			});

			copyButton.onclick = () => writeClipboardText(codeElement.textContent).then(() => Toast.ShowSuccess(Localizer.COPIED_VALUE));

			row.appendChild(document.createElementWithContents("div", copyButton, { className: "col-auto" }));
		}

		this.appendChild(row);
		this.repaint();
	}

	repaint() {
		const codeElement = this.querySelector("code");
		codeElement.removeAttribute("data-highlighted");

		CodeHighlight.highlightElement(codeElement);
	}

	attributeChanged(name, _, newValue) {
		if (name === "language") {
			const codeElement = this.querySelector("code");

			codeElement.className = "hljs";
			if (newValue) { codeElement.classList.add(`language-${newValue}`); }

			this.repaint();
		}
	}
}